import { useTheme } from './themeProvider';
import { Moon, Sun } from 'lucide-react';

export default function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  const isDark = theme === 'dark';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Sun className={`h-5 w-5 transition-colors ${isDark ? 'text-gray-400' : 'text-yellow-500'}`} />
      <button
        onClick={() => setTheme(isDark ? 'light' : 'dark')}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
          isDark ? 'bg-primary' : 'bg-gray-200'
        }`}
        role="switch"
        aria-checked={isDark}
        aria-label="Toggle dark mode"
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ${
            isDark ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <Moon className={`h-4 w-4 transition-colors ${isDark ? 'text-primary' : 'text-gray-400'}`} />
    </div>
  );
}
